<template>
  <div
    class="col-menu-color bg-tt-white border-radius-16"
    style="width:100%; box-shadow:20px 20px 50px; margin-right:24px; border-color:transparent"
  >
    <div
      style="display:flex; width:100%; flex-direction:column; justify-content:space-between; align-items:center;"
    >
      <div
        class="col-dark-blue"
        style="height:100px; display:flex; justify-content:center; align-items:center; font-size:24px; font-weight:600;"
      >
        {{$t('addAsset.uploadReady')}}
      </div>
      
      <div
        style="width:100%; height: calc(100vh - 300px); overflow-y:auto; overflow-x:hidden; display:flex; flex-direction:column; align-items:center"
      >
        <div
          class="col-dark-blue"
          style="min-height: 60px; font-size:16px; font-weight:300; text-align: center;"
        >
          {{$t('addAsset.checkmarkLayers')}}
        </div>
        
        <div style="display: flex; align-items: center; justify-content: center; gap: 10px; width: 100%;">
          
          <div v-if="items && items.length">
            <div
              style="height: calc(100vh - 380px); overflow-x: hidden; overflow-y:auto"
              class="custom">
              <div v-if="replaceableMedia.length > 0" class="col-dark-blue flex-center" style="font-size: 18px">
                {{$t('general.fields')}}
              </div>
              <div v-for="(list, index) in draggableLists">
                <div v-if="list.draggable">
                  <Draggable v-model="list.fields"
                             transition="200"
                             style="border-top: grey dotted 2px; border-bottom: grey dotted 2px; margin-top: 5px; margin-bottom: 5px">
                    <template v-slot:item="{ item }">
                      <div class="col-dark-blue bg-menu-color"
                           style="display:flex; align-items:center; justify-content:space-between; cursor:pointer; width:500px; height: 24px; border-radius:16px; padding: 16px; margin-top: 5px; margin-bottom: 5px;">
                        <Switch v-if="false" v-model="item.enabled" :value="item.enabled"/>
                        <div
                          style="margin:0 10px 0 10px; width:90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                          {{item.srcValue}}
                        </div>
                        <i class="pi pi-bars" style="font-size:24px;"></i>
                      </div>
                    </template>
                  </Draggable>
                </div>
                <div v-else>
                  <div v-for="field in list.fields">
                    <div
                      class="col-dark-blue bg-light-blue"
                      style="display:flex; align-items:center; justify-content:space-between; width:500px; height: 24px; border-radius:16px; padding: 16px; margin-top: 5px; margin-bottom: 5px;"
                    >
                      <Switch v-if="false" v-model="field.enabled" :value="field.enabled"/>
                      <div
                        style="margin:0 10px 0 10px; width:90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
                      >
                        {{field.srcValue}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div
            v-if="replaceableMedia.length > 0"
            style="height: calc(100vh - 380px); overflow-x: hidden; overflow-y:auto">
            <div class="col-dark-blue flex-center" style="font-size: 18px">
              {{$t('general.replaceableMedia')}}
            </div>
            
            <div v-for="replaceable in replaceableMedia"
                 class="col-dark-blue bg-menu-color"
                 style="display:flex; align-items:center; justify-content:space-between; cursor:pointer; width:500px; height: 24px; border-radius:16px; padding: 16px; margin-top: 5px; margin-bottom: 5px;">
              {{replaceable.name}}
            </div>
          </div>
        
        </div>
      </div>
      
      <!-- FOOTER -->
      
      <div
        style="width: 90%; height: 80px; display:flex; align-items:center; justify-content:space-between;"
      >
        <Button
          @click="
            $emit('update:transitionDir', 'slide-left');
            $emit('update:currentPage', currentPage - 1);
            $router.push({
              query: {
                id: $route.query.id,
                page: parseInt($route.query.page) - 1,
              },
            });
          "
          :label="$t('general.back')"
          class="border-radius-8 col-dark-blue bor-transparent bg-tt-white"
          style="min-width:120px; height:40px; padding:7px 6px 6px 8px;"
        />
        <div style="width:300px; display:flex; align-items:center; justify-content:space-between;">
          <i :class="'col-dark-blue pi ' + getCircleClass(1, currentPage)"></i>
          <i :class="'col-dark-blue pi ' + getCircleClass(2, currentPage)"></i>
          <i :class="'col-dark-blue pi ' + getCircleClass(3, currentPage)"></i>
          <i :class="'col-dark-blue pi ' + getCircleClass(4, currentPage)"></i>
          <i :class="'col-dark-blue pi ' + getCircleClass(5, currentPage)"></i>
        </div>
        
        <Button
          v-if="!isAssetVideo"
          @click="
            $emit('update:transitionDir', 'slide-right');
            $emit('update:currentPage', currentPage + 1);
            submitChanges();
            $router.push({
              query: {
                id: $route.query.id,
                page: parseInt($route.query.page) + 1,
              },
            });
          "
          :label=" $t('general.next')"
          class="border-radius-8 col-white bor-transparent bg-dark-blue"
          style="min-width:120px; height:40px; width:120px; padding:7px 6px 6px 8px;"
        />
        <Button
          v-else
          @click="onClickFinish()"
          :label=" $t('general.submit')"
          class="border-radius-8 col-white bor-transparent bg-dark-blue"
          style="min-width:120px; height:40px; width:120px; padding:7px 6px 6px 8px;"
        />
      </div>
    </div>
  </div>
</template>

<script src="./AddAssetViewCheckmark.ts"></script>
